import AxiosInstance from "../Utils/axios/axiosConfig";

export const getUnitData = async () => {
    const response = await AxiosInstance.get("/advanced/settings/");
    if (!response.data.error) {
      return response.data;
    } else {
      return Promise.reject(response);
    }
  };

  export const updateUnitData = async (body = []) => {
    const response = await AxiosInstance.put("/advanced/settings/", body);
    if (!response.data.error) {
      return response.data;
    } else {
      return Promise.reject(response);
    }
  };

  export const getExchangeRateData = async () => {
    const response = await AxiosInstance.get("/manual-exchange/");
    if (!response.data.error) {
      return response.data;
    } else {
      return Promise.reject(response);
    }
  };

  export const updateExchangeRateData = async (body,id) => {
    const response = await AxiosInstance.put(`/manual-exchange/?id=${id}`, body);
    if (!response.data.error) {
      return response.data;
    } else {
      return Promise.reject(response);
    }
  };

  export const getExchangeRateHistoryData = async () => {
    const response = await AxiosInstance.get("/exchange-rate/history/");
    if (!response.data.error) {
      return response.data;
    } else {
      return Promise.reject(response);
    }
  };

  export const updateSystemExchangeRate = async (body) => {
    const response = await AxiosInstance.put(`/manual-exchange/`, body);
    if (!response.data.error) {
      return response.data;
    } else {
      return Promise.reject(response);
    }
  };